import { defineComponent, ref, computed, onMounted, onBeforeUnmount, h, isVue2 } from 'vue-demi';

let unityInstanceIdentifier = 0;
function cssUnit(val) {
    const regx = /^\d+(px|em|%|vw|vh|rem)?$/;
    if (typeof val === 'number') {
        return val + 'px';
    }
    else {
        return regx.test(val)
            ? isNaN(val)
                ? val
                : val + 'px'
            : '100%';
    }
}
var index = defineComponent({
    name: 'UnityWebglComponent',
    props: {
        unity: {
            type: Object
        },
        width: {
            type: [String, Number],
            default: '100%'
        },
        height: {
            type: [String, Number],
            default: '100%'
        }
    },
    setup(props) {
        const canvas = ref(null);
        unityInstanceIdentifier++;
        const canvasStyle = computed(() => {
            return {
                width: cssUnit(props.width),
                height: cssUnit(props.height)
            };
        });
        onMounted(() => {
            var _a;
            if (canvas.value) {
                (_a = props.unity) === null || _a === void 0 ? void 0 : _a.create(canvas.value);
            }
        });
        onBeforeUnmount(() => {
            var _a;
            (_a = props.unity) === null || _a === void 0 ? void 0 : _a._unsafe_unload();
        });
        return () => h('canvas', isVue2
            ? {
                ref: canvas,
                attrs: {
                    id: `unity-canvas-${unityInstanceIdentifier}`
                },
                style: canvasStyle.value
            }
            : {
                ref: canvas,
                id: `unity-canvas-${unityInstanceIdentifier}`,
                style: canvasStyle.value
            });
    }
});

export { index as default };
